module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ffgGem/media/FC-9781398445444.jpg?1692049837709",
      "alt": "This image is the cover for the book Prior Knowledge"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Prior Knowledge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Summer of 1966. The Vietnam war is reaching its height, and Sonny has just enlisted in the United States Marine Corps. On his way home from the recruiting office he meets Joe, a 15-year-old from New York City. The two teenagers form a strong bond and spend every day in each other’s company until Sonny leaves for Vietnam. Years later, Hendricks is on a flight home from the war. A chance encounter with a fellow veteran leads him to upstate New York and a career in the New York State Police. But Hendricks is suffering partial memory loss due to trauma he suffered in the war. He needs to build a new life for himself, which he does successfully, until one day he finds himself in a situation that triggers emotions he cannot explain or control. Is Hendricks regaining his lost memories? And what is the significance of Sonny and Joe’s friendship all those years earlier? Hendricks’s journey is painful. Will it lead him to discover what has eluded him for so long?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mel Walsh\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in London in 1964, Mel Walsh spent her childhood in the London Borough of Hackney. In 1983, she trained as a registered nurse at St Bartholomew’s Hospital, London, and then as a midwife at The Homerton Hospital, London. She had a varied career, including working as a practice nurse in busy GP practices in Islington and Newham, and as a volunteer midwife in Lebanon during Civil War. After retiring from nursing, she moved to the west country. Prior Knowledge is her debut novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0